module.exports = __webpack_public_path__ + "img/finding-content.ceb08823.png";